import type { ResolvedRecipeMeResponse } from "@bitacorapro/api-types";
import { request } from "../client";

// GET /recipes/me — resolved recipe for the caller's org, decorated with
// resolved-only fields the recipe primitives don't carry (ADR-0020).
// `alDiaThresholdDays` (ADR-0027 H-02) is the one the dashboard's
// status-derivation screens need: the org's real "al día" staleness
// threshold, already merged with the server-side default in
// apps/core-api/src/routes/recipes.ts. Any authenticated org member can
// call this (unlike the admin-only org-detail config used by
// AdminOrgDetail.tsx). Before this (postventa share-link feature, S0)
// the dashboard had no recipe awareness at all — this also gates
// future capability-driven UI (e.g. the postventa observations feed)
// on `recipe.observationStatuses.length > 0`, never on `recipe.slug`.
export const recipesApi = {
  me: (): Promise<ResolvedRecipeMeResponse> =>
    request<ResolvedRecipeMeResponse>("GET", "core", "/recipes/me"),
};
